<template lang="html"> 
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card ">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-9">
                            <h5 class="card-title mb-4">Categories</h5>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-primary btn-block"
                                            @click="handleBtnNew">
                                <i class="mdi mdi-plus"></i>Add New Category
                            </button>
                        </div>
                    </div>
                    <div class="table-responsive w-100">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Name</th>
                                    <th class="border-bottom-0">Description</th>
                                    <th class="border-bottom-0"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, index) in categories">
                                    <td> {{ index + 1 }} </td>
                                    <td> {{ c.name }} </td>
                                    <td class="table-longdescription"> {{ c.description }} </td>
                                    <td>
                                        <b-button-group>
                                            <b-button variant="primary" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnEdit(c)">
                                                <i class="mdi mdi-table-edit"></i>
                                            </b-button>
                                            <b-button variant="danger" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnDelete(c)">
                                                <i class="mdi mdi-delete-forever"></i>
                                            </b-button>
                                        </b-button-group>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapState } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
import { pleaseWait } from 'please-wait'

export default{
  name: 'categories',
  extends: RestaurantChangedBase,
  computed: {
      ...mapState({
          categories: state => state.categories.categories
      })
  },
  methods: {
        handleBtnNew() {
            this.$router.push( { name: 'categoryaddform' });
          
        },
        handleBtnEdit(category) {
            this.$router.push({ name: 'categoryeditform', params: { id: category.categoryId }});
        },
        handleBtnDelete(category) {
            this.$store.dispatch('categories/deleteCategoryAction', category);
        }
    },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        this.$store.dispatch('categories/getCategoriesAction');
        this.setAction('categories/getCategoriesAction');
    }
}
</script>

<style lang="scss">

   .table-longdescription {
       max-width: 230px;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis
   }

   .table-button {
       max-width: 50px;
   }
</style>